import { render, staticRenderFns } from "./TemplateMoveList.vue?vue&type=template&id=5a281b2d&scoped=true&xmlns%3Ael-col=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml&"
import script from "./TemplateMoveList.vue?vue&type=script&lang=js&"
export * from "./TemplateMoveList.vue?vue&type=script&lang=js&"
import style0 from "./TemplateMoveList.vue?vue&type=style&index=0&id=5a281b2d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a281b2d",
  null
  
)

export default component.exports